import { ARTICLE_GRADIENTS } from './presets'
import { useCustomGradients } from './useCustomGradients'
import { GradientPresets } from './GradientPresets'

interface Props {
  value: string | null
  onChange: (g: string | null) => void
  disabled?: boolean
}

export const GradientPicker = ({ value, onChange, disabled = false }: Props) => {
  const { gradients: custom, add, remove } = useCustomGradients()

  return (
    <GradientPresets
      value={value}
      onSelect={onChange}
      presets={ARTICLE_GRADIENTS}
      custom={custom}
      onRemoveCustom={remove}
      disabled={disabled}
      onSaveCustom={(g) => {
        add(g)
        onChange(g)
      }}
    />
  )
}
